module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/oplaty.svg?14e9c88d";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/oplaty.svg
// module id = 1871
// module chunks = 0